<template>
  <footer class="d-flex flex-row justify-content-between">
    <p>Merci d'utiliser cet outil de la gestion du site de FC ROBI</p>
    <p>Version 1.0.0</p>
  </footer>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
name: "Footer"
}
</script>

<style lang="scss" scoped>
footer{
  & > p{
    color: var(--color-white, rgba(255, 255, 255, 1));
    margin-bottom: 0;
  }
  & > p:first-child{}
  & > p:last-child{
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue